module.exports = __webpack_public_path__ + "img/logo_CMG.cda77569.png";